module.exports = __webpack_public_path__ + "img/bike.7a845e84.jpg";